import React, {useEffect, useState} from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Snackbar,
    TextField,
    Typography
} from '@mui/material';
import {api} from "../../services/apiService";

export default function CreateUser() {
    const [form, setForm] = useState({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        role: 'user',
        companyId: ''
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({open: false, severity: 'success', message: ''});
    const [roles, setRoles] = useState([]);

    const validate = () => {
        const e = {};
        if (!form.firstname.trim()) e.firstname = 'Prénom requis';
        if (!form.lastname.trim()) e.lastname = 'Nom requis';
        if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = 'Email invalide';
        if (form.password.length < 6) e.password = 'Mot de passe (min 6 caractères)';
        if (!form.companyId.trim()) e.companyId = 'ID Entreprise requis';
        return e;
    };

    const handleChange = (key) => (event) => {
        setForm({...form, [key]: event.target.value});
        setErrors({...errors, [key]: undefined});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const eObj = validate();
        setErrors(eObj);
        if (Object.keys(eObj).length > 0) return;

        setLoading(true);
        try {
            api.post('auth/create_user', form).then((res) => {
                setSnackbar({open: true, severity: 'success', message: "Utilisateur créé avec succès"});
                setForm({firstname: '', lastname: '', email: '', password: '', companyId: '', role: 'user'});
            })
        } catch (err) {
            setSnackbar({open: true, severity: 'error', message: err.message || 'Échec de la création'});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        api.get('admin/user_roles')
            .then(res => {
                setRoles(res.data.roles);
            })
    }, []);

    return (
        <Container>
            <Typography variant="h1" gutterBottom>Création d'un utilisateur</Typography>

            <Box maxWidth={"lg"} component="form" sx={{gap: 2, display: "flex", flexDirection: "column"}}
                 onSubmit={handleSubmit} noValidate>
                <Box sx={{display: "flex", gap: 2}}>
                    <TextField
                        label="Prénom"
                        value={form.firstname}
                        onChange={handleChange('firstname')}
                        error={!!errors.firstname}
                        helperText={errors.firstname}
                        fullWidth
                    />

                    <TextField
                        label="Nom"
                        value={form.lastname}
                        onChange={handleChange('lastname')}
                        error={!!errors.lastname}
                        helperText={errors.lastname}
                        fullWidth
                    />
                </Box>

                <TextField
                    label="Email"
                    value={form.email}
                    onChange={handleChange('email')}
                    fullWidth
                    error={!!errors.email}
                    helperText={errors.email}
                    type="email"
                />

                <TextField
                    label="Mot de passe"
                    value={form.password}
                    onChange={handleChange('password')}
                    fullWidth
                    error={!!errors.password}
                    helperText={errors.password}
                    type="password"
                />

                <TextField
                    label="ID Entreprise"
                    value={form.companyId}
                    onChange={handleChange('companyId')}
                    fullWidth
                    error={!!errors.companyId}
                    helperText={errors.companyId}
                    type="text"
                />

                <FormControl fullWidth>
                    <InputLabel id="role-label">Rôle</InputLabel>
                    <Select
                        labelId="role-label"
                        value={form.role}
                        label="Rôle"
                        onChange={handleChange('role')}
                        variant={"outlined"}>
                        {roles.map(r => (
                            <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Grid item xs={12} sx={{display: 'flex', gap: 2, justifyContent: 'flex-end'}}>
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={() => setForm({
                            firstname: '',
                            lastname: '',
                            email: '',
                            password: '',
                            role: 'user'
                        })}
                        disabled={loading}
                    >
                        Réinitialiser
                    </Button>

                    <Button type="submit" variant="contained" disabled={loading}>
                        {loading ? <CircularProgress size={20} color="inherit"/> : 'Créer'}
                    </Button>
                </Grid>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={5000}
                onClose={() => setSnackbar(s => ({...s, open: false}))}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({...s, open: false}))}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
